import { Record } from "immutable";
import { Report } from "models/interfaces/reports/report";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: Report = {
    id: undefined,
    key: "",
    name: "",
    description: "",
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class ReportRecord extends Record(defaultValues) implements Report {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<Report>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Given a set of values for Report properties, create a new ReportRecord object from this
     * instance, overwriting the properties in the values parameter with values provided.
     *
     * @param {Partial<Report>} values The values to overwrite on this instance.
     * @returns A ReportRecord with values from this instance and the values parameter.
     */
    public with(values: Partial<Report>): ReportRecord {
        return new ReportRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ReportRecord };

// #endregion Exports
